import React, {useState, useRef, useEffect} from "react";
import {FontIcon} from "@/app/_components";
import {countryListData, CountryMeta, getCountryData} from "@/app/(redeem)/components/AddressCom/AddressComConfig";
import styles from "./AddressCom.module.css";
import {DriveUtil} from "@/Master/DriveUtil";
import Util from "@/Master/Util";

interface AddressComProps {
    onChange: (data: AddressData) => void;
    initData: AddressData;
}

export interface AddressData {
    countryCode: string;//国家地区
    country: string;
    state: string;
    city: string;
    zipCode: string;
}

//TODO 初始化数据有点问题
const AddressCom: React.FC<AddressComProps> = ({initData, onChange}) => {
    const [country, setCountry] = useState<string>(initData.country || "");
    const [state, setState] = useState<string>(initData.state || "");
    const [city, setCity] = useState<string>(initData.city || "");
    const [zipCode, setZipCode] = useState<string>(initData.zipCode || "");
    const [countryCode, setCountryCode] = useState<string>(initData.countryCode || "");

    const [isCountryOpen, setIsCountryOpen] = useState<boolean>(false);
    const [isStateOpen, setIsStateOpen] = useState<boolean>(false);
    const [isCityOpen, setIsCityOpen] = useState<boolean>(false);
    const [isZipCodeOpen, setIsZipCodeOpen] = useState<boolean>(false);

    const countries = Util.DeepClone(countryListData);
    const [curCountry, setCurCountry] =  useState<CountryMeta>(countryListData[0]);//当前选择国家

    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        //设置默认值
        if (!countryCode) setCountryCode(curCountry.countryCode);
        if (!country) onSelectCountry('country',curCountry.countryCode);
        if (!state) onSelectCountry('state',curCountry.states[0]);

        function handleClickOutside(event: MouseEvent | TouchEvent) {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                hideAll();
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, []);

    const handleSelect = (type: "city" | "zipCode", value: string) => {
        let newValues = {country, state, city, zipCode, countryCode};
        switch (type) {
            case "city":
                setCity(value);
                newValues.city = value;
                break;
            case "zipCode":
                setZipCode(value);
                newValues.zipCode = value;
                break;
        }
        onChange(newValues);
        hideAll();
    };

    const onSelectCountry = (type: "country" | "state", value: string) => {
        let newValues = {country, state, city, zipCode, countryCode};
        switch (type) {
            case "country":
                const meta = getCountryData(value);
                if (meta) {
                    setCurCountry(meta);
                    setCountry(meta.country);
                    setCountryCode(meta.countryCode);

                    setState("");
                    setCity("");
                    newValues.country = meta.country;
                    newValues.state = "";
                    newValues.city = "";
                }
                break;
            case "state":
                setState(value);
                setCity("");
                newValues.state = value;
                break;
        }
        onChange(newValues);
        hideAll();
    }


    const hideAll = () => {
        setIsCountryOpen(false);
        setIsStateOpen(false);
        setIsCityOpen(false);
        setIsZipCodeOpen(false);
    };

    return (
        <div className={styles.container} ref={ref}>
            <div className={styles.formGroup}>
                <label htmlFor="country" className={styles.label}>
                    Country:
                </label>
                <div className={styles.customDropdown}>
                    <input
                        type="text"
                        id="country"
                        value={country}
                        placeholder="Select Country"
                        readOnly
                        onClick={() => setIsCountryOpen(!isCountryOpen)}
                        className={styles.input}
                    />
                    <FontIcon
                        icon={`ani ${styles.shrink} ${
                            isCountryOpen ? "s-shrink-top" : "s-shrink-bottom"
                        }`}
                        click={() => setIsCountryOpen(!isCountryOpen)}
                    />
                    {isCountryOpen && (
                        <div className={styles.dropdownList}>
                            {countries.map((item) => (
                                <div
                                    key={item.countryCode}
                                    className={styles.dropdownItem}
                                    onClick={() => onSelectCountry('country',item.countryCode)}
                                >
                                    {item.country}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <div className={styles.formGroup}>
                <label htmlFor="state" className={styles.label}>
                    State/Province:
                </label>
                <div className={styles.customDropdown}>
                    <input
                        type="text"
                        id="state"
                        value={state}
                        placeholder="Select State"
                        readOnly
                        onClick={() => setIsStateOpen(!isStateOpen)}
                        className={styles.input}
                    />
                    <FontIcon
                        icon={`${styles.shrink} ${
                            isStateOpen ? "s-shrink-top" : "s-shrink-bottom"
                        }`}
                        click={() => setIsStateOpen(!isStateOpen)}
                    />
                    {isStateOpen && (
                        <div className={styles.dropdownList}>
                            {curCountry.states.map((item) => (
                                <div
                                    key={item}
                                    className={styles.dropdownItem}
                                    onClick={() => onSelectCountry("state", item)}
                                >
                                    {item}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <div className={styles.formGroup}>
                <label htmlFor="city" className={styles.label}>
                    City:
                </label>
                <div className={styles.customDropdown}>
                    <input
                        type="text"
                        id="city"
                        value={city}
                        placeholder="Your City"
                        // readOnly
                        onClick={() => setIsCityOpen(!isCityOpen)}
                        className={styles.input}
                        onChange={(e) => handleSelect("city", e.target.value)}
                    />
                </div>
            </div>
            <div className={styles.formGroup}>
                <label htmlFor="zipCode" className={styles.label}>
                    Zip Code:
                </label>
                <div className={styles.customDropdown}>
                    <input
                        type="text"
                        id="zipCode"
                        value={zipCode}
                        placeholder="Your Zip Code"
                        // readOnly
                        onClick={() => setIsZipCodeOpen(!isZipCodeOpen)}
                        className={styles.input}
                        onChange={(e) => handleSelect("zipCode", e.target.value)}
                    />
                </div>
            </div>
        </div>
    );
};

export default AddressCom;
